export * from './upload.interface';
export * from './upload-patch.interface';
